<template>
  <div class="ui-tabs">
    <div class="links s-16 w-500">
      <slot name="link" :activetab="activetab" :activetabfun="activetabfun"></slot>
    </div>
    <div class="content contentBody">
      <slot name="body" :activetab="activetab"></slot>
    </div>

  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      activetab: 'default'
    }
  },
  methods: {
    activetabfun(code){
      this.activetab=code;
    }
  },
  created() {
    let hash = location.hash.replace(/#/g, '');
    if( hash != ""){
      this.activetabfun(hash);
    }else{
      this.activetabfun(this.activetab);
    }
  },
  watch: {
    $route(to,from)
    {
      let hash = location.hash.replace(/#/g, '');
      if( hash != ""){
        this.activetabfun(hash);
      }else{
        this.activetabfun(this.activetab);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-tabs {}
.links {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 2em;
  text-align: center;
  & > * {
    display: inline-block;
    padding: 0.8em 1.5em;
    cursor: pointer;
    border-radius: 100px;
    border: 1px solid var(--light);
    margin: 0.1em;
    transition: 0.3s;
    &:hover {
      background: var(--light);
      color: var(--dark);
    }
    &.active {
      background: var(--color);
      color: #fff;
    }
  }
}
.contentBody{
  padding: 50px;
}
</style>
<style>
.layout-content-page .content{
  width: 100% !important;
}
</style>
